window.DeviceBookingValidation = (() => {

    function getField(selector) {
        return document.querySelector(selector);
    }

    function getValue(selector) {
        const field = getField(selector);

        if (!field) {
            return '';
        }

        return String(field.value || '').trim();
    }

    function getNumber(selector) {
        const value = parseInt(getValue(selector), 10);

        return isNaN(value) ? 0 : value;
    }

    function showError(message) {

        const box = document.querySelector(
            '.device-booking__step.is-active #device-booking-validation'
        );

        if (!box) {
            return;
        }

        box.textContent = message;
        box.hidden = false;

    }

    function hideError() {

        const box = document.querySelector(
            '.device-booking__step.is-active #device-booking-validation'
        );

        if (!box) {
            return;
        }

        box.hidden = true;
        box.textContent = '';

    }

    /*
    -----------------------------------------
    STEP 1
    -----------------------------------------
    */

    function validateDevices() {

        const laptop =
            getNumber('[name="properties[Laptop]"]');

        const tablet =
            getNumber('[name="properties[Tablet]"]');

        const phone =
            getNumber('[name="properties[Phone]"]');

        const others =
            getNumber('[name="properties[Others]"]');

        const total =
            laptop +
            tablet +
            phone +
            others;

        if (total <= 0) {

            showError(
                'Please select at least one device for destruction.'
            );

            return false;

        }

        hideError();

        return true;

    }

    /*
    -----------------------------------------
    STEP 2
    -----------------------------------------
    */

    function validateCertificate() {

    const selected = document.querySelector(
        'input[name="properties[Certificate of Destruction]"]:checked'
    );

    console.log('Certificate Selected:', selected);

    if (!selected) {

        showError(
            'Please select whether you require a Certificate of Destruction.'
        );

        return false;

    }

    hideError();

    return true;

}
    /*
    -----------------------------------------
    STEP 3
    -----------------------------------------
    */

   function validateAddress() {

        const fullName = getValue('[name="properties[Full Name]"]');
        const phone = getValue('[name="properties[Phone Number]"]');
        const property = getValue('[name="properties[Property Type]"]');
        const address = getValue('[name="properties[Collection Address]"]');
        const postalCode = getValue('[name="properties[Postal Code]"]');
        const liftAccess = getValue('[name="properties[Lift Access]"]');

        if (!fullName) {
            showError('Please enter your full name.');
            return false;
        }

        if (!phone) {
            showError('Please enter your phone number.');
            return false;
        }

        if (!property) {
            showError('Please select your property type.');
            return false;
        }

        if (!address) {
            showError('Please enter your collection address.');
            return false;
        }

        if (!postalCode) {
            showError('Please enter your postal code.');
            return false;
        }

        if (!liftAccess) {
            showError('Please select whether lift access is available.');
            return false;
        }

        hideError();

        return true;

    }

    /*
    -----------------------------------------
    STEP 4
    -----------------------------------------
    */

    function validateCalendar() {

        hideError();

        return true;

    }

    /*
    -----------------------------------------
    MAIN ROUTER
    -----------------------------------------
    */

    function validateStep(step) {

        switch (Number(step)) {

            case 1:
                return validateDevices();

            case 2:
                return validateCertificate();

            case 3:
                return validateAddress();

            case 4:
                return validateCalendar();

            default:
                return true;

        }

    }

    /*
    -----------------------------------------
    LIVE VALIDATION
    -----------------------------------------
    */

    function init() {

        document.addEventListener('input', (event) => {

            const field = event.target;

            if (!field.closest('.device-booking')) {
                return;
            }

            validateDevices();

        });

        document.addEventListener('change', (event) => {

            const field = event.target;

            if (!field.closest('.device-booking')) {
                return;
            }

            validateDevices();

        });

    }

    return {

        init,

        validateStep,

        validateDevices,

        validateCertificate,

        validateAddress,

        validateCalendar,

        showError,

        hideError

    };

})();